import { grey, red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// The two PSE price series on the prices page. Different hues, not shades of
// one: the preliminary is a cornflower blue, the settled value violet, so
// they read apart at a glance while both stay clear of the red that means
// "below zero" and the grey/teal the rest of the app uses.
export const priceSeriesColors = (mode: "light" | "dark") => ({
  pse: mode === "dark" ? "#6EA8FE" : "#2F6FED",
  pseSettled: mode === "dark" ? "#C79BFF" : "#7E3FF2",
});

export const createAppTheme = (mode: "light" | "dark") =>
  createTheme({
    cssVariables: true,
    spacing: 4,
    palette: {
      mode,
      primary: {
        main: mode === "dark" ? grey[100] : grey[900],
      },
      secondary: {
        main: "#0ea4a2",
      },
      tertiary: {
        main: grey[500],
      },
      error: {
        main: red.A400,
      },
      background: {
        default: mode === "dark" ? "#000000" : "#ffffff",
        paper: mode === "dark" ? "#1F1F1F" : "#f2f4f4",
      },
      action: {
        hover: mode === "dark" ? grey[800] : grey[200],
      },
    },
    typography: {
      fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"].join(","),
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: ({ theme }) => ({
            height: "100%",
            backgroundColor:
              theme.palette.mode === "dark" ? "#121212" : "#f2f4f4",
            color: theme.palette.mode === "dark" ? "#fff" : "#000",
            ...(theme.palette.mode === "light" && {
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
              border: `1.5px solid ${grey[300]}`,
            }),
          }),
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: 8,
            ":last-child": {
              paddingBottom: 8,
            },
          },
        },
      },
    },
  });
